import axios from 'axios';
import { API_URL, toCompany, pollingSubscription } from './adapters';

// Backed by /api/companies on the VPS. Field translation lives in adapters.js
// because the collection uses Chinese column names.

export const getAllCompanies = async () => {
  const { data } = await axios.get(`${API_URL}/companies`);
  return data.map(toCompany);
};

export const getCompany = async (companyId) => {
  try {
    const { data } = await axios.get(`${API_URL}/companies/${companyId}`);
    return toCompany(data);
  } catch (error) {
    if (error.response?.status === 404) return null;
    throw error;
  }
};

export const getCompanyByCode = async (companyCode) => {
  try {
    const { data } = await axios.get(
      `${API_URL}/companies/by-code/${encodeURIComponent(companyCode)}`
    );
    return toCompany(data);
  } catch (error) {
    if (error.response?.status === 404) return null;
    throw error;
  }
};

export const createCompany = async (companyData) => {
  const { data } = await axios.post(`${API_URL}/companies/upsert`, {
    名稱: companyData.companyName,
    廣告: companyData.allowGlobalAds !== undefined ? companyData.allowGlobalAds : true,
    soundSettings: companyData.soundSettings
  });
  return toCompany(data.company);
};

export const updateCompany = async (companyId, updates) => {
  const { data } = await axios.post(`${API_URL}/companies/upsert`, {
    '🔒 Row ID': companyId,
    名稱: updates.companyName,
    廣告: updates.allowGlobalAds,
    soundSettings: updates.soundSettings
  });
  return toCompany(data.company);
};

export const deleteCompany = async (companyId) => {
  await axios.delete(`${API_URL}/companies/${companyId}`);
  return true;
};

// Companies carry no credentials on the VPS side, so "login" is simply
// resolving the code the operator typed. Kept async for call-site compatibility.
export const verifyCompanyLogin = async (companyCode) => {
  return getCompanyByCode(companyCode);
};

export const subscribeToCompany = (companyId, callback) =>
  pollingSubscription(() => getCompany(companyId), callback);

export const subscribeToAllCompanies = (callback) =>
  pollingSubscription(getAllCompanies, callback);
